import log from 'salvo-lite/log'
import AjaxCart from '../helpers/AjaxCart'

class Product {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
        this._accordions = document.querySelectorAll('.product__accordion-header')
        this._prev = document.referrer
        this._breadcrumb = document.querySelector('.breadcrumbs .visually-hidden')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (this._prev.includes('collection')) {
            let title = sessionStorage.getItem('title')
            if (title) {
                this._breadcrumb.querySelector('a').textContent = title
                this._breadcrumb.querySelector('a').href = this._prev
                this._breadcrumb.classList.remove('visually-hidden')
            }
        }
        document.addEventListener('click', e => e.target.hasAttribute('data-add-to-cart') && this._addToCart())
        for (var i = 0; i < this._accordions.length; i++) {
            this._accordions[i].addEventListener('click', e => {
                document.dispatchEvent(new Event('accordion-change'))
            })
        }
    }

    async _addToCart () {
        const quantity = 1
        const selectedVariant = parseInt(document.querySelector('select[name="id"]').value)
        const payload = {quantity, id: selectedVariant}
        await AjaxCart.addItem(payload)
    }
}

export default Product



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Product.js